import { useState, useEffect } from 'react';
import { useAppSelector } from 'store/hooks';
import { selectVacantInfo } from 'store';
import { selectTranslations } from 'store/translation/translation.slice';
import { selectUserInfo } from 'store/user/user.slice';
import { useTranslation } from 'hooks/useTranslation';
import { useGetProfileDataQuery } from 'services/talento';
import { REMOVE_WORDS_REGEX, EXTRA_SPACES_REGEX } from 'utils/constants/generalsConstans';
import { Numbers } from 'utils/helpers/dictionaries';
import { IResponseProfile } from 'utils/interfaces';

const useGetName = () => {
  const { translations, isLoading } = useAppSelector(selectTranslations);
  const { t } = useTranslation(translations, isLoading);
  const { vacant, isLoadingVacant } = useAppSelector(selectVacantInfo);
  const { email } = useAppSelector(selectUserInfo);
  
  
  const {
    data: profileData,
  } = useGetProfileDataQuery<IResponseProfile>({ email }, { refetchOnMountOrArgChange: true });
  
  const [fullName, setFullName] = useState('');
  const [vacantName, setVacantName] = useState('');
  const [firstLetterName, setFirstLetterName] = useState('');
  const [firstLetterSecondName, setFirstLetterSecondName] = useState('');
  const [preferredName, setPreferredName] = useState('');
  const [firstNameComplete, setFirstName] = useState(''); 
  const [firstLastNameComplete, setFirstLastName] = useState('');
  const [lastName, setLastName] = useState('');                    
  const [lastNameInitial, setLastNameInitial] = useState('');      

  useEffect(() => {
    if (!isLoadingVacant && vacant) {
      const { fullName, vacant: nameVacant } = vacant || {};
      setFullName(fullName);
      setVacantName(nameVacant);
      
     
      const userPreferredName = profileData?.preferredName || '';
      setPreferredName(userPreferredName);
      
      const auxName = fullName?.replace(REMOVE_WORDS_REGEX, ' ');
      const splitedName = auxName?.replace(EXTRA_SPACES_REGEX, ' ').trim();
      const splitedNameArray = splitedName ? splitedName.split(' ') : [];

      const firstName = splitedNameArray.length > Numbers.zero 
        ? splitedNameArray[Numbers.zero]
        : '';
      
 
      const nameForGreeting = userPreferredName || firstName;
      setFirstName(nameForGreeting); 

      const firstLastName = splitedNameArray.length > Numbers.one
        ? splitedNameArray[Numbers.one] 
        : '';
      setFirstLastName(firstLastName); 
      const paternalSurname = splitedNameArray.length > 2
        ? splitedNameArray[2] 
        : splitedNameArray.length > 1
        ? splitedNameArray[1] 
        : '';
      
      setLastName(paternalSurname);
      setLastNameInitial(paternalSurname ? paternalSurname.charAt(0).toUpperCase() : '');


     
      const nameForInitials = userPreferredName || auxName?.replace(EXTRA_SPACES_REGEX, ' ').trim();
      const initialsArray = nameForInitials ? nameForInitials.split(' ') : splitedNameArray;

      setFirstLetterName(
        initialsArray.length > Numbers.zero 
          ? initialsArray[Numbers.zero].charAt(Numbers.zero).toUpperCase()
          : firstName.charAt(Numbers.zero).toUpperCase()
      );
      
      const secondNameLetter = initialsArray.length > Numbers.one
        ? initialsArray[initialsArray.length - Numbers.one].charAt(Numbers.zero).toUpperCase()
        : splitedNameArray.length > Numbers.one
        ? splitedNameArray[splitedNameArray.length - Numbers.one].charAt(Numbers.zero).toUpperCase()
        : '';
      setFirstLetterSecondName(secondNameLetter);
    }
  }, [vacant, isLoadingVacant, profileData]);

  return {
    t,
    fullName,
    vacantName,
    isLoadingVacant,
    firstLetterName,
    firstLetterSecondName,
    firstNameComplete,
    firstLastNameComplete,
    preferredName,
    lastName,          
    lastNameInitial,    
  };
};

export default useGetName;
